import Dexie from 'dexie'
import { from, Observable, of } from 'rxjs'

import { ITaxCode } from './../models/itax-code.model'

export class TaxCodeDatabase extends Dexie {
  private taxCodes: Dexie.Table<ITaxCode, number>

  constructor() {
    super('TaxCodeDB')
    this.version(1).stores({
      taxCodes: 'ticId, parentTic, sstSortOrder',
    })
    this.taxCodes = this.table('taxCodes')
  }

  public totalCodes(): Observable<number> {
    return from(this.taxCodes.count())
  }

  public saveTaxCodes(taxCodes: ITaxCode[]): Observable<number> {
    return from(this.taxCodes.bulkPut(taxCodes))
  }

  public updateTaxCode(taxCode: ITaxCode) {
    return from(this.taxCodes.put(taxCode))
  }

  public clearTaxCodes(): Observable<void> {
    return from(this.taxCodes.clear())
  }

  public getTaxCodes(): Observable<ITaxCode[]> {
    return from(this.taxCodes.orderBy('ticId').toArray())
  }

  public getTopTaxCodes(): Observable<ITaxCode[]> {
    return from(
      this.taxCodes
        .orderBy('sstSortOrder')
        .filter((taxCode) => !taxCode.parentTic)
        .toArray()
    )
  }

  public getChildren(parentTic: number): Observable<ITaxCode[]> {
    return from(
      this.taxCodes
        .orderBy('sstSortOrder')
        .filter((taxCode) => taxCode.parentTic === parentTic)
        .toArray()
    )
  }

  public getTaxCode(ticId: number): Observable<ITaxCode | undefined> {
    if (ticId === null || ticId < 0 || isNaN(ticId)) {
      return of(null)
    }

    return from(this.taxCodes.get({ ticId }))
  }

  public getSsutaStates(): Observable<ITaxCode[]> {
    return from(this.taxCodes.filter((state) => state.isSSUTA).toArray())
  }

  public findTaxCodeByName(name: string): Observable<ITaxCode[]> {
    return from(this.taxCodes.where('name').startsWithIgnoreCase(name).toArray())
  }
}
